/**
 * 用户端  个人中心
 */
 <template>
    <div class="login-page">
      <topInfo></topInfo>
      <cusNav></cusNav>
      <!-- 主体内容 -->
      <div class="eval-content">
         <div class="eval-con-top">
            <div class="eval-con-title"><span style="font-weight: 700;">丨</span>个人资料</div>
            <div class="eval-con-btn" style="margin-left: auto;" @click="showEditPsd()">修改密码</div>
         </div>
         <!-- 个人资料 -->
         <div>
            <el-form :model="userInfoForm" class="eval-form" label-width="80px" style="padding-bottom: 10px;text-align: left;">
               <el-form-item label="姓名：" prop="name">
                  <el-input size="small"  v-model.trim="userInfoForm.name" auto-complete="off" clearable style="width: 920px;"></el-input>
                  <!-- <el-button size="mini" type="primary" style="float: right;width: 100px;height: 30px;margin-top: 6px;">修改</el-button> -->
               </el-form-item>
               <el-form-item label="电话：" prop="mobile">
                  <el-input size="small"  v-model.trim="userInfoForm.mobile" auto-complete="off" clearable style="width: 920px;" disabled></el-input>
               </el-form-item>
               <div style="display: flex;">
                  <div>
                     <el-form-item label="账户：" prop="role_name">
                        <el-input size="small"  v-model.trim="userInfoForm.role_name" auto-complete="off" style="width: 300px;" clearable disabled></el-input>
                     </el-form-item>
                  </div>
                  <div style="margin-left: 120px;">
                     <el-form-item label="积分：" prop="points">
                        <el-input size="small"  v-model.trim="userInfoForm.points" auto-complete="off" style="width: 180px;" clearable disabled></el-input>
                     </el-form-item>
                  </div>
                  <div style="margin-left: -40px;">
                     <el-form-item>
                        <el-button size="small" type="primary" title="点击充值积分" style="background-color: #2A91DD;" @click="showRecharge()">积分充值</el-button>
                     </el-form-item>
                  </div>
                  <div style="margin-left: -40px;">
                     <el-form-item>
                        <el-button size="small" type="primary" title="查询积分记录" style="background-color: #2A91DD;" @click="showPointsLog()">积分记录</el-button>
                     </el-form-item>
                  </div>
               </div>
               <div style="display: flex;">
                  <div>
                     <el-form-item label="公司：" prop="company">
                        <el-input size="small" :disabled="userInfoForm.role_id!=3" v-model.trim="userInfoForm.company" auto-complete="off" style="width: 300px;" clearable></el-input>
                     </el-form-item>
                  </div>
                  <div style="margin-left: 120px;">
                     <el-form-item label="部门：" prop="points">
                        <el-input size="small"  :disabled="userInfoForm.role_id!=3" v-model.trim="userInfoForm.department" auto-complete="off" style="width: 300px;" clearable></el-input>
                     </el-form-item>
                  </div>
                  <div style="margin-left: -40px;">
                     <el-form-item>
                        <el-button size="small" :disabled="userInfoForm.role_id!=3" type="primary" title="查询积分记录" style="background-color: #2A91DD;" @click="commitUserInfo()">修改信息</el-button>
                     </el-form-item>
                  </div>
               </div>
            </el-form>
         </div>
      </div>
      <!-- 案件订单列表 -->
      <div class="eval-content">
         <div class="eval-con-top">
            <div class="eval-con-title"><span style="font-weight: 700;">丨</span>案件评估订单</div>
            <div class="title-flex-end">
               <!-- <div class="eval-con-btn">批量下载</div> -->
               <div class="areaPicker" style="margin-right: 10px;">
                     <span style="color: #606266;font-size: 14px;">支付时间：</span>
                     <el-date-picker
                           v-model="caseDate"
                           type="daterange"
                           range-separator="-"
                           start-placeholder="开始时间"
                           end-placeholder="结束时间"
                           format="yyyy.MM.dd"
                           value-format="yyyy-MM-dd"
                           :picker-options="pickerOptions">
                  </el-date-picker>
                  <span class="clearBtn" style="margin-left: 4px;" title="清除时间" @click="clearDate()">清除</span>
                  <span class="clearBtn" style="margin-left: 4px;" title="多订单合并申请发票" @click="showChooseOrder(1)">申请开票</span>
               </div>
               <div class="eval-con-search">
                  <el-input v-model="formInlineOrder.search" clearable placeholder="请输入关键词">
                     <el-button slot="append" style="color: #ffffff;" @click="getCusAdminOrderData()">搜索</el-button>
                  </el-input>
               </div>
            </div>
         </div>
         <div class="eval-table" style="padding-bottom: 10px;">
            <el-table size="small" :data="orderData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
               <el-table-column align="center" type="selection" width="40" fixed="left">
               </el-table-column>
               <el-table-column align="center" type="index" label="序号" width="60">
               </el-table-column>
               <el-table-column prop="title" align="center" label="专利名称" show-overflow-tooltip>
               </el-table-column>
               <el-table-column prop="type" align="center" label="专利类型" show-overflow-tooltip>
               </el-table-column>
               <el-table-column prop="area" align="center" label="专利领域" show-overflow-tooltip>
               </el-table-column>
               <el-table-column prop="total_fee" align="center" label="支付金额(元)" show-overflow-tooltip>
               </el-table-column>
               <el-table-column prop="points" align="center" label="消耗积分" show-overflow-tooltip>
               </el-table-column>
               <el-table-column prop="eval_type" align="center" label="评测方式" show-overflow-tooltip>
                  <template slot-scope="scope">
                     <span v-if="scope.row.eval_type==1">智能评测</span>
                     <span v-if="scope.row.eval_type==2">专家评测</span>
                  </template>
               </el-table-column>
               <el-table-column prop="pay_time" align="center" label="支付时间" show-overflow-tooltip>
               </el-table-column>
               <el-table-column align="center" label="操作">
                  <template slot-scope="scope">
                     <el-button v-if="scope.row.ticket_id <= 0" size="mini" title="申请开票" type="primary" style="background-color: #2A91DD;" @click="showApplyTicket(scope.row,1)">申请开票</el-button>
                     <el-button v-if="scope.row.ticket_id > 0" size="mini" title="查看发票" type="primary" style="background-color: #2A91DD;" @click="checkTicket(scope.row)">获取发票</el-button>
                  </template>
               </el-table-column>
            </el-table>
            <!-- 分页组件 -->
            <Pagination v-bind:child-msg="pageparmOrder" @callFather="callFatherOrder"></Pagination>
         </div>
      </div>
      <!-- 积分订单列表 -->
      <div class="eval-content">
         <div class="eval-con-top">
            <div class="eval-con-title"><span style="font-weight: 700;">丨</span>积分充值订单</div>
            <div class="title-flex-end">
               <div class="areaPicker" style="margin-right: 0px;">
                     <span style="color: #606266;font-size: 14px;">支付时间：</span>
                     <el-date-picker
                           v-model="rechargeDate"
                           type="daterange"
                           range-separator="-"
                           start-placeholder="开始时间"
                           end-placeholder="结束时间"
                           format="yyyy.MM.dd"
                           value-format="yyyy-MM-dd"
                           :picker-options="pickerOptions">
                  </el-date-picker>
                  <span class="clearBtn" style="margin-left: 4px;" title="清除时间" @click="clearRechargeDate()">清除</span>
                  <span class="clearBtn" style="margin-left: 4px;" title="多订单合并申请发票" @click="showChooseOrder(2)">申请开票</span>
                  <span class="clearBtn" style="margin-left: 4px;padding: 10.5px 20px;font-size: 14px;" @click="getCusAdminRechargeOrderData()">搜索</span>
               </div>
               <!-- <div class="eval-con-search">
                  <el-input v-model="formInlinePointsOrder.search" clearable placeholder="请输入关键词">
                     <el-button slot="append" style="color: #ffffff;" @click="getCusAdminRechargeOrderData()">搜索</el-button>
                  </el-input>
               </div> -->
            </div>
         </div>
         <div class="eval-table" style="padding-bottom: 10px;">
            <el-table size="small" :data="pointsOrderData" highlight-current-row v-loading="loadPonitsOrdering" border element-loading-text="拼命加载中" style="width: 100%;">
               <el-table-column align="center" type="selection" width="40" fixed="left">
               </el-table-column>
               <el-table-column align="center" type="index" label="序号" width="60">
               </el-table-column>
               <el-table-column prop="total_fee" align="center" label="订单金额(元)" show-overflow-tooltip>
               </el-table-column>
               <el-table-column prop="points" align="center" label="积分充值数量" show-overflow-tooltip>
               </el-table-column>
               <el-table-column prop="status" align="center" label="订单状态" show-overflow-tooltip>
                  <template slot-scope="scope">
                     <span v-if="scope.row.pay_type==2&&scope.row.status==1">未支付</span>
                     <span v-if="scope.row.pay_type==2&&scope.row.status==2">已完成</span>
                     <span v-if="scope.row.pay_type==3&&scope.row.status==1">等待上传转账凭证</span>
                     <span v-if="scope.row.pay_type==3&&scope.row.status==3">凭证已上传,处理中</span>
                     <span v-if="scope.row.pay_type==3&&scope.row.status==2">已完成</span>
                     <span v-if="scope.row.pay_type==3&&scope.row.status==4">凭证审核不通过</span>
                  </template>
               </el-table-column>
               <el-table-column prop="pay_type" align="center" label="支付方式" show-overflow-tooltip>
                  <template slot-scope="scope">
                     <span v-if="scope.row.pay_type==1">微信支付</span>
                     <span v-if="scope.row.pay_type==2">支付宝支付</span>
                     <span v-if="scope.row.pay_type==3">对公转账</span>
                  </template>
               </el-table-column>
               <el-table-column prop="add_time" align="center" label="添加时间" show-overflow-tooltip>
               </el-table-column>
               <el-table-column prop="pay_time" align="center" label="支付时间" show-overflow-tooltip>
               </el-table-column>
               <el-table-column align="center" label="操作" width="300">
                  <template slot-scope="scope">
                     <el-button v-if="scope.row.ticket_id<=0&&scope.row.status==2" style="background-color: #2A91DD;" size="mini" title="申请开票" type="primary" @click="showApplyTicket(scope.row,2)">申请开票</el-button>
                     <el-button v-if="scope.row.ticket_id > 0" style="background-color: #2A91DD;" size="mini" title="查看发票" type="primary" @click="checkTicket(scope.row)">获取发票</el-button>
                     <el-button v-if="scope.row.pay_type==3&&scope.row.status==1" style="background-color: #2A91DD;" size="mini" title="上传转账凭证" type="primary" @click="showUploadVoucher(scope.row)">上传凭证</el-button>
                     <el-button v-if="scope.row.pay_type==3&&scope.row.status==4" style="background-color: #2A91DD;" size="mini" title="上传转账凭证" type="primary" @click="showUploadVoucher(scope.row)">上传凭证</el-button>
                     <el-button v-if="scope.row.pay_type==3&&scope.row.status==1" size="mini" title="删除订单" type="danger" @click="delChargeOrder(scope.row)">删除</el-button>
                     <el-button v-if="scope.row.pay_type==3&&scope.row.status==4" size="mini" title="删除订单" type="danger" @click="delChargeOrder(scope.row)">删除</el-button>
                     <el-button v-if="scope.row.pay_type==2&&scope.row.status==1" size="mini" title="删除订单" type="danger" @click="delChargeOrder(scope.row)">删除</el-button>
                     <el-button v-if="scope.row.pay_type==3&&scope.row.status==3" size="mini" title="查看转账凭证" style="background-color: #2A91DD;" type="primary" @click="showVoucher(scope.row)">查看凭证</el-button>
                     <el-button v-if="scope.row.pay_type==3&&scope.row.status==1&&scope.row.ticket_id<=0" size="mini" title="针对需要见票汇款的单位支持预开发票" style="background-color: #2A91DD;" type="primary" @click="showApplyTicket(scope.row,2)">预开票</el-button>
                     <el-button v-if="scope.row.pay_type==3&&scope.row.status==4&&scope.row.ticket_id<=0" size="mini" title="针对需要见票汇款的单位支持预开发票" style="background-color: #2A91DD;" type="primary" @click="showApplyTicket(scope.row,2)">预开票</el-button>
                  </template>
               </el-table-column>
            </el-table>
            <!-- 分页组件 -->
            <Pagination v-bind:child-msg="pageparmPointsOrder" @callFather="callFatherPointsOrder"></Pagination>
         </div>
      </div>
      <!-- 账户管理列表 -->
      <div v-if="userInfoForm.role_id!=3" class="eval-content">
         <div class="eval-con-top">
            <div class="eval-con-title"><span style="font-weight: 700;">丨</span>账户管理</div>
            <div class="title-flex-end">
               <div class="eval-con-btn" @click="showAddCusAdmin()">新增账户</div>
               <div class="eval-con-btn" @click="showExportCusAdmin()">导入账户</div>
               <div class="eval-con-search" style="margin-left: 10px;">
                  <el-input v-model="formInlineAccount.search" clearable>
                     <el-button slot="append" style="color: #ffffff;" @click="getCustomerData()">搜索</el-button>
                  </el-input>
               </div>
            </div>
            
         </div>
         <div class="eval-table" style="padding-bottom: 10px;">
            <el-table size="small" :data="accountData" highlight-current-row v-loading="loadAccounting" border element-loading-text="拼命加载中" style="width: 100%;">
               <el-table-column align="center" type="selection" width="40" fixed="left">
               </el-table-column>
               <el-table-column align="center" type="index" label="序号" width="60">
               </el-table-column>
               <el-table-column prop="name" align="center" label="姓名" show-overflow-tooltip>
               </el-table-column>
               <el-table-column prop="mobile" align="center" label="手机号" show-overflow-tooltip>
               </el-table-column>
               <el-table-column prop="points" align="center" label="积分" show-overflow-tooltip>
               </el-table-column>
               <el-table-column prop="company" align="center" label="单位" show-overflow-tooltip>
               </el-table-column>
               <el-table-column prop="department" align="center" label="部门" show-overflow-tooltip>
               </el-table-column>
               <el-table-column prop="role_name" align="center" label="角色" show-overflow-tooltip>
               </el-table-column>
               <!-- <el-table-column prop="eval_type" align="center" label="评测方式" show-overflow-tooltip>
                  <template slot-scope="scope">
                     <span v-if="scope.row.eval_type==1">智能评测</span>
                     <span v-if="scope.row.eval_type==2">专家评测</span>
                     <span></span>
                  </template>
               </el-table-column> -->
               <el-table-column prop="add_time" align="center" label="添加时间" show-overflow-tooltip>
               </el-table-column>
               <el-table-column align="center" label="操作" min-width="120">
                  <template slot-scope="scope">
                     <el-button size="mini" type="primary" style="background-color: #2A91DD;" @click="showDistribution(scope.row)">分配积分</el-button>
                     <el-button size="mini" type="danger" @click="delCusAdmin(scope.row)">删除</el-button>
                  </template>
               </el-table-column>
            </el-table>
            <!-- 分页组件 -->
            <Pagination v-bind:child-msg="pageparmAccount" @callFather="callFatherAccount"></Pagination>
         </div>
      </div>
      <!-- 发票列表 -->
      <div class="eval-content" style="margin-bottom: 40px;">
         <div class="eval-con-top">
            <div class="eval-con-title"><span style="font-weight: 700;">丨</span>发票抬头管理</div>
            <div class="title-flex-end">
               <div class="eval-con-btn" @click="showEditInvoice()">添加抬头</div>
            </div>
         </div>
         <div style="padding-bottom: 20px;" v-loading="loadInvoiceing">
             <div v-if="invoiceData.length > 0" class="invoice-item" v-for="item in invoiceData">
               <div class="invoice-type" v-if="item.invoice_type == 1&&item.apply_type == 2">个人（普票）</div>
               <div class="invoice-type" v-if="item.invoice_type == 1&&item.apply_type == 1">企业（普票）</div>
               <div class="invoice-type" style="background-color: #FF8B36;" v-if="item.invoice_type == 2">企业（专票）</div>
               <div class="invoice-label">抬头：</div>
               <div class="invoice-text" style="width: 380px;">{{ item.name }}</div>
               <div class="invoice-label">邮箱：</div>
               <div class="invoice-text" style="width: 240px;">{{ item.email }}</div>
               <el-button size="mini" type="primary" style="margin-left: 40px;background-color: #2A91DD;" @click="showEditInvoice(item)">修改</el-button>
               <el-button size="mini" type="danger" style="margin-left: 20px;" @click="delInvocie(item)">删除</el-button>
             </div>
             <div v-if="invoiceData.length <= 0">
               <div style="text-align: center;padding: 10px;color: #999999;font-size: 14px;">暂无数据</div>
             </div>
         </div> 
      </div>
      <!-- 添加发票弹窗 -->
      <div class="edit-invoice">
         <el-dialog v-dialogDrag :close-on-click-modal="false" :visible.sync="editInvocieVisible" width="400px">
            <div style="font-size: 16px;font-weight: 700;margin-top: -20px;">{{ invoiceTitle }}</div>
            <el-form :model="invoiceForm" style="margin-top: 30px;">
               <div style="display: flex;background-color: #ECEDF4;border-radius: 50px;">
                  <div  v-if="invoiceForm.invoice_type == 1" class="invoice-btn invoice-btn-active" @click="checkInvoiceOne()">增值税普通发票</div>
                  <div  v-else class="invoice-btn" @click="checkInvoiceOne()">增值税普通发票</div>
                  <div v-if="invoiceForm.invoice_type == 2" class="invoice-btn invoice-btn-active" @click="checkInvoiceTwo()">增值税专用发票</div>
                  <div v-else class="invoice-btn" @click="checkInvoiceTwo()">增值税专用发票</div>
               </div>
               <div v-if="invoiceForm.invoice_type == 1" style="display: flex;background-color: #ECEDF4;border-radius: 50px;margin-top: 10px;">
                  <div v-if="invoiceForm.apply_type == 2" class="invoice-btn invoice-btn-active" @click="checkInvoiceThree()">个人</div>
                  <div v-else class="invoice-btn" @click="checkInvoiceThree()">个人</div>
                  <div v-if="invoiceForm.apply_type == 1" class="invoice-btn invoice-btn-active" @click="checkInvoiceFour()">企业</div>
                  <div v-else class="invoice-btn" @click="checkInvoiceFour()">企业</div>
               </div>
               <div style="margin-top: 10px;">
                  <div style="text-align: left;">发票抬头</div>
                  <el-input size="small" auto-complete="off" class="invocie-input" v-model.trim="invoiceForm.name" clearable></el-input>
               </div>
               <div v-if="invoiceForm.apply_type == 1" style="margin-top: 10px;">
                  <div style="text-align: left;">税号</div>
                  <el-input size="small" auto-complete="off" class="invocie-input" v-model.trim="invoiceForm.ein" clearable></el-input>
               </div>
               <div v-if="invoiceForm.invoice_type == 2" style="margin-top: 10px;">
                  <div style="text-align: left;">开户银行</div>
                  <el-input size="small" auto-complete="off" class="invocie-input" v-model.trim="invoiceForm.bank" clearable></el-input>
               </div>
               <div v-if="invoiceForm.invoice_type == 2" style="margin-top: 10px;">
                  <div style="text-align: left;">银行账户</div>
                  <el-input size="small" auto-complete="off" class="invocie-input" v-model.trim="invoiceForm.bank_account" clearable></el-input>
               </div>
               <div v-if="invoiceForm.invoice_type == 2" style="margin-top: 10px;">
                  <div style="text-align: left;">注册电话</div>
                  <el-input size="small" auto-complete="off" class="invocie-input" v-model.trim="invoiceForm.tel" clearable></el-input>
               </div>
               <div v-if="invoiceForm.invoice_type == 2" style="margin-top: 10px;">
                  <div style="text-align: left;">注册地址</div>
                  <el-input size="small" auto-complete="off" class="invocie-input" v-model.trim="invoiceForm.address" clearable></el-input>
               </div>
               <div style="margin-top: 10px;">
                  <div style="text-align: left;">邮箱</div>
                  <el-input size="small" auto-complete="off" class="invocie-input" v-model.trim="invoiceForm.email" clearable></el-input>
               </div>
               <el-button style="width: 100%;margin-top: 20px;" type="primary" @click="commitInvoice()">确认添加</el-button>
            </el-form>
         </el-dialog>
      </div>
      <!-- 修改密码弹窗 -->
      <div class="edit-password">
         <el-dialog v-dialogDrag :close-on-click-modal="false" :visible.sync="editPsdVisible" width="400px">
            <div style="font-size: 16px;font-weight: 700;margin-top: -20px;">{{ invoiceTitle }}</div>
            <el-form :model="passwordForm" style="margin-top: 30px;">
               <div style="margin-top: 10px;">
                  <div style="text-align: left;"><span style="color: #ff2c2c;margin-left: -6px;padding-right: 2px;">*</span>新密码</div>
                  <el-input size="small" auto-complete="off" type="password" class="invocie-input" v-model.trim="passwordForm.password" clearable></el-input>
               </div>
               <div style="margin-top: 10px;">
                  <div style="text-align: left;"><span style="color: #ff2c2c;margin-left: -6px;padding-right: 2px;">*</span>重复密码</div>
                  <el-input size="small" auto-complete="off" type="password" class="invocie-input" v-model.trim="passwordForm.passwords" clearable></el-input>
               </div>
               <el-button style="width: 100%;margin-top: 20px;background-color: #2A91DD;" type="primary" @click="commitPassword()">确认修改</el-button>
            </el-form>
         </el-dialog>
      </div>
      <!-- 申请发票 -->
       <div>
         <el-dialog v-dialogDrag :close-on-click-modal="false" :visible.sync="showApplyTicketVisible" width="560px">
            <div style="font-size: 16px;font-weight: 700;margin-top: -20px;">申请开票</div>
            <!-- 选择发票 -->
             <div>
               <div style="display: flex;font-size: 16px;">
                  <div style="width: 10px;height: 24px;background-color: #2A91DD;border-radius: 4px;margin-right: 12px;"></div>
                  <div style="color: #333;">抬头选择</div>
               </div>
               <div style="width: 480px;padding: 24px 20px;background-color: #fff;box-shadow: 0 5px 10px #cec7e0a8;border-radius: 10px;margin-top: 20px;">
                  <div style="display: flex;">
                     <el-select v-model="applyTicketForm.invoice_id" placeholder="请选择发票" clearable style="width: 340px;" @change="changeInvoice()">
                        <el-option v-for="item in invoiceData" :label="item.name" :key="item.name" :value="item.id"></el-option>
                     </el-select>
                     <el-button style="margin-left: 40px;" @click="showEditInvoice()">添加抬头</el-button>
                  </div>
               </div>
               <div style="display: flex;font-size: 16px;margin-top: 20px;">
                  <div style="width: 10px;height: 24px;background-color: #2A91DD;border-radius: 4px;margin-right: 12px;"></div>
                  <div style="color: #333;">发票详情</div>
               </div>
               <div style="width: 480px;padding: 24px 20px;background-color: #fff;box-shadow: 0 5px 10px #cec7e0a8;border-radius: 10px;margin-top: 20px;text-align: left;">
                  <div>发票抬头：{{ chooseInvocieData.name }}</div>
                  <div style="margin-top: 4px;" v-if="chooseInvocieData.ein&&chooseInvocieData.ein.length>0">税<span style="color: #fff;">占位</span>号：{{ chooseInvocieData.ein }}</div>
                  <div style="margin-top: 4px;" v-if="chooseInvocieData.invoice_type==1">类<span style="color: #fff;">占位</span>型：增值税普通发票</div>
                  <div style="margin-top: 4px;" v-if="chooseInvocieData.invoice_type==2">类<span style="color: #fff;">占位</span>型：增值税专用发票</div>
                  <div style="margin-top: 4px;" v-if="chooseInvocieData.bank&&chooseInvocieData.bank.length>0">开户银行：{{ chooseInvocieData.bank }}</div>
                  <div style="margin-top: 4px;" v-if="chooseInvocieData.bank_account&&chooseInvocieData.bank_account.length>0">银行账户：{{ chooseInvocieData.bank_account }}</div>
                  <div style="margin-top: 4px;" v-if="chooseInvocieData.tel&&chooseInvocieData.tel.length>0">注册电话：{{ chooseInvocieData.tel }}</div>
                  <div style="margin-top: 4px;" v-if="chooseInvocieData.address&&chooseInvocieData.address.length>0">注册地址：{{ chooseInvocieData.address }}</div>
                  <div style="margin-top: 4px;">开票金额：￥{{ applyTicketForm.total_fee }}</div>
                  <div style="margin-top: 4px;" v-if="chooseInvocieData.email&&chooseInvocieData.email.length>0">邮<span style="color: #fff;">占位</span>箱：{{ chooseInvocieData.email }}</div>
               </div>
             </div>
             <div style="margin-top: 20px;display: flex;">
               <el-button style="margin-left: auto;margin-right: 0px;background-color: #2A91DD;" type="primary" @click="commitApplyTicket()">提交申请</el-button>
             </div>
         </el-dialog>
       </div>
       <!-- 积分充值 -->
       <div>
         <el-dialog v-dialogDrag :close-on-click-modal="false" :visible.sync="showRechargeVisible" width="560px">
            <div style="font-size: 16px;font-weight: 700;margin-top: -20px;">积分充值</div>
            <div>
               <div style="display: flex;font-size: 16px;">
                  <div style="width: 10px;height: 24px;background-color: #2A91DD;border-radius: 4px;margin-right: 12px;"></div>
                  <div style="color: #333;">充值数量</div>
               </div>
               <div style="width: 480px;padding: 24px 20px;background-color: #fff;box-shadow: 0 5px 10px #cec7e0a8;border-radius: 10px;margin-top: 20px;">
                  <div style="display: flex;">
                     <el-input placeholder="请输入充值数量" v-model="rechargeForm.points" clearable @input="listenPoints()"></el-input>
                  </div>
                  <div style="text-align: left;color: #999999;margin-top: 4px;">注：1积分等于1元人民币,建议每次充值为100的倍数</div>
               </div>
               <div style="display: flex;font-size: 16px;margin-top: 20px;">
                  <div style="width: 10px;height: 24px;background-color: #2A91DD;border-radius: 4px;margin-right: 12px;"></div>
                  <div style="color: #333;">支付方式</div>
               </div>
               <div style="width: 480px;padding: 24px 20px;background-color: #fff;box-shadow: 0 5px 10px #cec7e0a8;border-radius: 10px;margin-top: 20px;">
                  <div style="display: flex;">
                     <div class="pay_type_item">
                        <el-checkbox v-model="rechargeForm.pay_type" :true-label="2" :false-label="0" style="width: 140px;padding: 0 10px;align-items: center;height: 50px;justify-content: space-between;line-height: 50px;">
                           <div class="type_item-right" style="font-size: 14px;margin-left: 10px;">
                              <img style="width: 14px;margin-right: 4px;" src="../../assets/eval/pay_zhifubao.png">支付宝支付
                           </div>
                        </el-checkbox>
                     </div>
                     <div class="pay_type_item">
                        <el-checkbox v-model="rechargeForm.pay_type" :true-label="3" :false-label="0" style="width: 140px;padding: 0 10px;align-items: center;height: 50px;justify-content: space-between;line-height: 50px;">
                           <div class="type_item-right" style="font-size: 14px;margin-left: 10px;">
                              对公转账
                           </div>
                        </el-checkbox>
                     </div>
                     <div class="pay_type_item">
                        <el-checkbox v-model="rechargeForm.pay_type" :true-label="4" :false-label="0" style="width: 140px;padding: 0 10px;align-items: center;height: 50px;justify-content: space-between;line-height: 50px;">
                           <div class="type_item-right" style="font-size: 14px;margin-left: 10px;">
                              扫码转账
                           </div>
                        </el-checkbox>
                     </div>
                  </div>
               </div>
               <div v-if="rechargeForm.pay_type == 3" style="margin-top: 20px;">
                  <div style="display: flex;font-size: 16px;">
                     <div style="width: 10px;height: 24px;background-color: #2A91DD;border-radius: 4px;margin-right: 12px;"></div>
                     <div style="color: #333;">账户信息</div>
                  </div>
                  <div style="width: 480px;padding: 24px 20px;background-color: #fff;box-shadow: 0 5px 10px #cec7e0a8;border-radius: 10px;margin-top: 20px;text-align: left;">
                     <div>
                        <span>收款单位:</span>
                        <span>{{ taxData.company_name }}</span>
                     </div>
                     <div>
                        <span>收款账户:</span>
                        <span>{{ taxData.back_account }}</span>
                     </div>
                     <div>
                        <span>开户银行:</span>
                        <span>{{ taxData.bank_name }}</span>
                     </div>
                     <div>
                        <span>联系电话:</span>
                        <span>{{ taxData.company_tel }}</span>
                     </div>
                     <div>
                        <span>单位税号:</span>
                        <span>{{ taxData.tax_regis_number }}</span>
                     </div>
                     <div>
                        <span>注册地址:</span>
                        <span>{{ taxData.company_address }}</span>
                     </div>
                     <div>
                        <span>转账金额:</span>
                        <span v-if="rechargeForm.points && rechargeForm.points > 0">￥{{ rechargeForm.points }}</span>
                     </div>
                     <div style="text-align: left;color: #999999;margin-top: 4px;">注：1积分等于1元人民币,建议每次充值为100的倍数</div>
                     <div style="text-align: left;color: #999999;margin-top: 4px;">注：小额订单建议使用支付宝,大额订单可对公转账,转账后请到我的转账单中上传转账凭证,便于工作人员核实</div>
                     <div style="text-align: left;color: #999999;margin-top: 4px;">注：针对需要见票汇款的单位，支持预开票服务，生成转账单后到下方对应的积分充值订单点击预开票按钮申请开票</div>
                  </div>
               </div>
               <div v-if="rechargeForm.pay_type == 4" style="margin-top: 20px;">
                  <div style="display: flex;font-size: 16px;">
                     <div style="width: 10px;height: 24px;background-color: #2A91DD;border-radius: 4px;margin-right: 12px;"></div>
                     <div style="color: #333;">二维码信息</div>
                  </div>
                  <div style="width: 240px;margin-left: auto;margin-right: auto;border: 1px solid #ECEDF4;border-radius: 4px;margin-top: 10px;padding: 4px;">
                     <img :src="taxData.bank_transfer_code" style="width: 100%;height: 100%;"></img>
                  </div>
                  <div style="text-align: left;color: #999999;margin-top: 4px;">注：1积分等于1元人民币,建议每次充值为100的倍数</div>
                  <div style="text-align: left;color: #999999;margin-top: 4px;">注：小额订单建议使用支付宝,大额订单可对公转账,转账后请到我的转账单中上传转账凭证,便于工作人员核实</div>
                  <div style="text-align: left;color: #999999;margin-top: 4px;">注：扫码支付金额请与转账单一致,转账成功后将转账成功信息上传到对应转账单中,便于工作人员核实</div>
               </div>
               <div style="margin-top: 20px;display: flex;">
                  <el-button v-if="rechargeForm.pay_type == 2" style="margin-left: auto;margin-right: 0px;" type="primary" @click="creRechargeOrder()">立即支付</el-button>
                  <el-button v-if="rechargeForm.pay_type == 3" style="margin-left: auto;margin-right: 0px;" type="primary" @click="creTaxOrder()">生成转账单</el-button>
                  <el-button v-if="rechargeForm.pay_type == 4" style="margin-left: auto;margin-right: 0px;" type="primary" @click="creTaxOrder()">生成转账单</el-button>
               </div>
            </div>
         </el-dialog>
       </div>
       <!-- 新增账户 -->
       <div class="edit-customer">
            <el-dialog v-dialogDrag :close-on-click-modal="false" :visible.sync="showAddCusAdminVisible" width="400px">
               <div style="font-size: 16px;font-weight: 700;margin-top: -20px;">新增账户</div>
               <el-form :model="customerForm" style="margin-top: 30px;">
                  <div style="margin-top: 10px;">
                     <div style="text-align: left;" prop="name">姓名</div>
                     <el-input size="small" auto-complete="off" class="invocie-input" v-model.trim="customerForm.name" placeholder="请填写姓名" clearable></el-input>
                  </div>
                  <div style="margin-top: 10px;">
                     <div style="text-align: left;" prop="mobile">手机号</div>
                     <el-input size="small" auto-complete="off" class="invocie-input" v-model.trim="customerForm.mobile" placeholder="请填写手机号" clearable></el-input>
                  </div>
                  <div style="margin-top: 10px;">
                     <div style="text-align: left;" prop="role_id">角色</div>
                     <el-select v-if="userInfoForm.role_id==1" v-model="customerForm.role_id" placeholder="请选择角色" style="width: 100%;margin-top: 4px;" filterable clearable @change="listenRole()">
                        <el-option
                           v-for="item in roleDataUp"
                           :key="item.role_id"
                           :label="item.role_name"
                           :value="item.role_id"></el-option>
                     </el-select>
                     <el-select v-if="userInfoForm.role_id==2" v-model="customerForm.role_id" placeholder="请选择角色" style="width: 100%;margin-top: 4px;" filterable clearable>
                        <el-option
                           v-for="item in roleDataLow"
                           :key="item.role_id"
                           :label="item.role_name"
                           :value="item.role_id"></el-option>
                     </el-select>
                  </div>
                  <div v-if="customerForm.role_id ==3&&userInfoForm.role_id==1" style="margin-top: 10px;">
                     <div style="text-align: left;" prop="pid">上级账户</div>
                     <el-select v-model="customerForm.pid" placeholder="请选择上级账户" style="width: 100%;margin-top: 4px;" filterable clearable>
                        <el-option
                           v-for="item in pCustomerData"
                           :key="item.id"
                           :label="item.name"
                           :value="item.id"></el-option>
                     </el-select>
                  </div>
                  <div style="margin-top: 10px;">
                     <div style="text-align: left;">单位</div>
                     <el-input size="small" auto-complete="off" class="invocie-input" v-model.trim="customerForm.company" placeholder="请填写单位" clearable></el-input>
                  </div>
                  <div style="margin-top: 10px;">
                     <div style="text-align: left;">部门</div>
                     <el-input size="small" auto-complete="off" class="invocie-input" v-model.trim="customerForm.department" placeholder="请填写部门" clearable></el-input>
                  </div>
                  <div style="margin-top: 10px;">
                     <div style="text-align: left;">邮箱</div>
                     <el-input size="small" auto-complete="off" class="invocie-input" v-model.trim="customerForm.email" placeholder="请填写邮箱" clearable></el-input>
                  </div>
                  <el-button style="width: 100%;margin-top: 20px;" type="primary" @click="commitCustomer()">确认添加</el-button>
               </el-form>
            </el-dialog>
         </div>
       <!-- 导入账户 -->
       <div>
         <el-dialog v-dialogDrag :close-on-click-modal="false" :visible.sync="importCustomerVisible" width="400px">
               <div style="font-size: 16px;font-weight: 700;margin-top: -20px;">导入账户</div>
               <el-form :model="importCustomerForm" style="margin-top: 30px;">
                  <div style="margin-top: 10px;">
                     <div style="text-align: left;" prop="role_id">角色</div>
                     <el-select v-if="userInfoForm.role_id == 1" v-model="importCustomerForm.role_id" placeholder="请选择角色" style="width: 100%;margin-top: 4px;" filterable clearable @change="listenRoleImport()">
                        <el-option
                           v-for="item in roleDataUp"
                           :key="item.role_id"
                           :label="item.role_name"
                           :value="item.role_id"></el-option>
                     </el-select>
                     <el-select v-if="userInfoForm.role_id == 2" v-model="importCustomerForm.role_id" placeholder="请选择角色" style="width: 100%;margin-top: 4px;" filterable clearable>
                        <el-option
                           v-for="item in roleData"
                           :key="item.role_id"
                           :label="item.role_name"
                           :value="item.role_id"></el-option>
                     </el-select>
                  </div>
                  <div v-if="importCustomerForm.role_id == 3&&userInfoForm.role_id == 1" style="margin-top: 10px;">
                     <div style="text-align: left;" prop="pid">上级账户</div>
                     <el-select v-model="importCustomerForm.pid" placeholder="请选择上级账户" style="width: 100%;margin-top: 4px;" filterable clearable>
                        <el-option
                           v-for="item in pCustomerData"
                           :key="item.id"
                           :label="item.name"
                           :value="item.id"></el-option>
                     </el-select>
                  </div>
                  <div style="margin-top: 10px;">
                     <div style="text-align: left;">上传Excel表格</div>
                     <el-upload
                        class="upload-demo"
                        :action=importCustomerAction
                        :headers=setHeader
                        :before-upload="beforeImportCustomer"
                        :before-remove="beforeImportCusRemove"
                        :on-remove="handleImportCusRemove"
                        :on-success="handleImportCusSuccess"
                        style="text-align: left;margin-top: 10px;">
                        <el-button size="small" type="primary">选择文件</el-button>
                        <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
                     </el-upload>
                     <div v-if="importCustomerForm.customerData.length > 0" style="font-size: 12px;text-align: left;margin-top: 4px;">
                        <div>已成功读取 <span style="color: #F56C6C;">{{ importCustomerForm.customerData.length }}</span> 条数据,如确认无误,请点击确认导入</div>
                     </div>
                     <div style="font-size: 12px;text-align: left;margin-top: 6px;">
                        注：请<span style="color: #409EFF;cursor: pointer;" title="点击下载模板" @click="downloadImportCusTemp()">下载模版</span>填充数据上传,密码默认为手机号
                     </div>
                  </div>
                  <el-button style="width: 100%;margin-top: 20px;" type="primary" @click="commitImport()">确认导入</el-button>
               </el-form>
         </el-dialog>
       </div>
      
       <!-- 扫码支付 -->
      <el-dialog v-dialogDrag :close-on-click-modal="false" :visible.sync="orderCodeVisible" width="400px">
         <div class="pay_price">
            <div style="font-size: 16px;color: #333;font-weight: 700;margin-top: -10px;">订单支付</div>
            <div style="margin-top: 10px;margin-bottom: 20px;">请使用支付宝扫码支付</div>
            <img :src="orderResult.pay_code" style="width: 150px;height: 150px;margin-bottom: 40px;" />
            <div style="margin-bottom: 20px;">
               <span>充值积分数量：</span>
               <span>{{ orderResult.points }}</span>
            </div>
            <div style="margin-bottom: 20px;">
               <span>实际支付：</span>
               <span style="color: #ff2c2c;font-size: 16px;">￥{{ orderResult.total_fee }}</span>
            </div>
         </div>
      </el-dialog>
      <!-- 积分日志 -->
      <div>
         <el-dialog v-dialogDrag :close-on-click-modal="false" :visible.sync="showPointsLogVisible" width="760px">
            <div style="font-size: 16px;font-weight: 700;margin-top: -20px;">积分记录</div>
            <el-table size="small" :data="pointsLogData" highlight-current-row v-loading="loadPointsLog" border element-loading-text="拼命加载中" style="width: 100%;margin-top: 20px;" height="400px">
               <el-table-column align="center" type="index" label="序号" width="60">
               </el-table-column>
               <el-table-column prop="type" align="center" label="类型" show-overflow-tooltip>
                  <template slot-scope="scope">
                     <span v-if="scope.row.type == 1">积分充值</span>
                     <span v-if="scope.row.type == 2">申请预评估</span>
                     <span v-if="scope.row.type == 3">积分分配</span>
                  </template>
               </el-table-column>
               <el-table-column prop="desc" align="center" label="积分操作" show-overflow-tooltip>
               </el-table-column>
               <el-table-column prop="content" align="center" label="备注" show-overflow-tooltip>
               </el-table-column>
               <el-table-column prop="add_time" align="center" label="时间" show-overflow-tooltip>
               </el-table-column>
            </el-table>
         </el-dialog>
      </div>
    
      <!-- 分配积分 -->
      <div>
         <el-dialog v-dialogDrag :close-on-click-modal="false" :visible.sync="showDistributeVisible" width="560px">
            <div style="font-size: 16px;font-weight: 700;margin-top: -20px;">积分分配</div>
            <div>
               <div style="display: flex;font-size: 16px;">
                  <div style="width: 10px;height: 24px;background-color: #2A91DD;border-radius: 4px;margin-right: 12px;"></div>
                  <div style="color: #333;">分配数量</div>
               </div>
               <div style="width: 480px;padding: 24px 20px;background-color: #fff;box-shadow: 0 5px 10px #cec7e0a8;border-radius: 10px;margin-top: 20px;">
                  <div style="display: flex;">
                     <el-input placeholder="请输入分配数量" v-model="distributeForm.points" clearable></el-input>
                  </div>
                  <div style="text-align: left;color: #999999;margin-top: 4px;">注：1积分等于1元人民币,建议每次分配为100的倍数</div>
               </div>
               <div style="margin-top: 20px;display: flex;">
                  <el-button style="margin-left: auto;margin-right: 0px;" type="primary" @click="commitDistribute()">立即分配</el-button>
               </div>
            </div>
         </el-dialog>
      </div>

      <!-- 上传凭证 -->
      <div>
         <el-dialog v-dialogDrag :close-on-click-modal="false" :visible.sync="showUploadVoucherVisible" width="560px">
            <div style="font-size: 16px;font-weight: 700;margin-top: -20px;">上传转账凭证</div>
            <div>
               <div style="width: 480px;padding: 24px 20px;background-color: #fff;box-shadow: 0 5px 10px #cec7e0a8;border-radius: 10px;margin-top: 20px;">
                  <div style="text-align: left;color: #999999;margin-top: 4px;">注：请点击下方选择文件按钮,选择需要上传的转账凭证</div>
                  <div style="text-align: left;color: #999999;margin-top: 4px;"><span style="color: #fff;">注：</span>上传成功后会自动关闭上传弹窗</div>
               </div>
               <div style="margin-top: 20px;display: flex;justify-content: flex-end;">
                  <el-upload
                     class="upload-demo"
                     :action=uploadVoucherAction
                     :list-type="'text'"
                     :hide-upload-list="true"
                     :data=voucherData
                     :headers=setHeader
                     :before-upload="beforeUploadVoucher"
                     :on-success="handleUploadVoucherSuccess"
                     style="text-align: left;margin-top: 10px;">
                     <el-button style="margin-left: auto;margin-right: 0px;" type="primary">选择文件</el-button>
                  </el-upload>
               </div>
            </div>
         </el-dialog>
      </div>
      <!-- 发票预览 -->
      <div>
         <el-dialog v-dialogDrag :close-on-click-modal="false" title="" :visible.sync="billPreviewVisible" width="50%">
            <div v-if="bill_type == 'pdf'">
               <iframe :src="bill_url" style="height: 60vh;width: 100%;"></iframe>
            </div>
            <div v-else>
               <img :src="bill_url" style="width: 100%;">
            </div>
         </el-dialog>
      </div>

      <!-- 多订单申请开票 -->
       <div>
         <el-dialog v-dialogDrag :close-on-click-modal="false" :visible.sync="showChooseOrderVisible" width="560px">
            <div style="font-size: 16px;font-weight: 700;margin-top: -20px;">申请开票</div>
            <!-- 选择发票 -->
            <div>
               <div style="display: flex;font-size: 16px;">
                  <div style="width: 10px;height: 24px;background-color: #2A91DD;border-radius: 4px;margin-right: 12px;"></div>
                  <div style="color: #333;">抬头选择</div>
               </div>
               <div style="width: 480px;padding: 24px 20px;background-color: #fff;box-shadow: 0 5px 10px #cec7e0a8;border-radius: 10px;margin-top: 20px;">
                  <div style="display: flex;">
                     <el-select v-model="applyTicketForm.invoice_id" placeholder="请选择发票" clearable style="width: 340px;" @change="changeInvoice()">
                        <el-option v-for="item in invoiceData" :label="item.name" :key="item.name" :value="item.id"></el-option>
                     </el-select>
                     <el-button style="margin-left: 40px;" @click="showEditInvoice()">添加抬头</el-button>
                  </div>
               </div>
               <div style="display: flex;font-size: 16px;margin-top: 20px;">
                  <div style="width: 10px;height: 24px;background-color: #2A91DD;border-radius: 4px;margin-right: 12px;"></div>
                  <div style="color: #333;">发票详情</div>
               </div>
               <div style="width: 480px;padding: 24px 20px;background-color: #fff;box-shadow: 0 5px 10px #cec7e0a8;border-radius: 10px;margin-top: 20px;text-align: left;">
                  <div>发票抬头：{{ chooseInvocieData.name }}</div>
                  <div style="margin-top: 4px;" v-if="chooseInvocieData.ein&&chooseInvocieData.ein.length>0">税<span style="color: #fff;">占位</span>号：{{ chooseInvocieData.ein }}</div>
                  <div style="margin-top: 4px;" v-if="chooseInvocieData.invoice_type==1">类<span style="color: #fff;">占位</span>型：增值税普通发票</div>
                  <div style="margin-top: 4px;" v-if="chooseInvocieData.invoice_type==2">类<span style="color: #fff;">占位</span>型：增值税专用发票</div>
                  <div style="margin-top: 4px;" v-if="chooseInvocieData.bank&&chooseInvocieData.bank.length>0">开户银行：{{ chooseInvocieData.bank }}</div>
                  <div style="margin-top: 4px;" v-if="chooseInvocieData.bank_account&&chooseInvocieData.bank_account.length>0">银行账户：{{ chooseInvocieData.bank_account }}</div>
                  <div style="margin-top: 4px;" v-if="chooseInvocieData.tel&&chooseInvocieData.tel.length>0">注册电话：{{ chooseInvocieData.tel }}</div>
                  <div style="margin-top: 4px;" v-if="chooseInvocieData.address&&chooseInvocieData.address.length>0">注册地址：{{ chooseInvocieData.address }}</div>
                  <div style="margin-top: 4px;">开票金额：￥{{ applyTicketForm.total_fee }}</div>
                  <div style="margin-top: 4px;" v-if="chooseInvocieData.email&&chooseInvocieData.email.length>0">邮<span style="color: #fff;">占位</span>箱：{{ chooseInvocieData.email }}</div>
               </div>
             </div>
             <!-- 订单列表 -->
               <div style="display: flex;font-size: 16px;margin-top: 20px;">
                  <div style="width: 10px;height: 24px;background-color: #2A91DD;border-radius: 4px;margin-right: 12px;"></div>
                  <div style="color: #333;">订单列表</div>
               </div>
               <el-table size="small" :data="applyTicketData" highlight-current-row border element-loading-text="拼命加载中" style="width: 100%;margin-top: 10px;" ref="multipleTable" @selection-change="handleSelectionChange">
                  <el-table-column align="center" type="selection" width="40" fixed="left">
                  </el-table-column>
                  <el-table-column align="center" type="index" label="序号">
                  </el-table-column>
                  <el-table-column prop="total_fee" align="center" label="订单金额(元)" show-overflow-tooltip>
                  </el-table-column>
                  <el-table-column prop="status" align="center" label="订单状态" show-overflow-tooltip>
                     <template slot-scope="scope">
                        <span v-if="scope.row.pay_type==2&&scope.row.status==1">未支付</span>
                        <span v-if="scope.row.pay_type==2&&scope.row.status==2">已完成</span>
                        <span v-if="scope.row.pay_type==3&&scope.row.status==1">等待上传转账凭证</span>
                        <span v-if="scope.row.pay_type==3&&scope.row.status==3">凭证已上传,处理中</span>
                        <span v-if="scope.row.pay_type==3&&scope.row.status==2">已完成</span>
                        <span v-if="scope.row.pay_type==3&&scope.row.status==4">凭证审核不通过</span>
                     </template>
                  </el-table-column>
                  <el-table-column prop="pay_type" align="center" label="支付方式" show-overflow-tooltip>
                     <template slot-scope="scope">
                        <span v-if="scope.row.pay_type==1">微信支付</span>
                        <span v-if="scope.row.pay_type==2">支付宝支付</span>
                        <span v-if="scope.row.pay_type==3">对公转账</span>
                     </template>
                  </el-table-column>
                  <el-table-column prop="pay_time" align="center" label="支付时间" width="120" show-overflow-tooltip>
                  </el-table-column>
               </el-table>
               <div style="margin-top: 20px;display: flex;">
                  <el-button style="margin-left: auto;margin-right: 0px;background-color: #2A91DD;" type="primary" @click="commitCheckApplyTicket()">提交申请</el-button>
               </div>
         </el-dialog>
       </div>
    </div>
 </template>
 <script>
   import {
      getUserInvoicePageList,
      editInvoice,
      delInvoice,
      changeUserPassword,
      editUserInfo,
      getCusAdminOrderPageList,
      addInvoiceApply,
      getCusAdminApplyInvoice,
      getSubAccount,
      getCusAdminPageList,
      editCusAdmin,
      webUrl,
      importCusAdmin,
      createRechargeOrder,
      getRechargeOrderInfo,
      distributionPoints,
      delCusAdmin,
      getCusPointsLog,
      getUserInfo,
      docUrl,
      getTransferAccountConfig,
      createRechargeTaxOrder,
      getCusAdminRechargeOrderPageList,
      getImportCusExcelTemp,
      cusDelChargeOrder,
      getCanApplyTicketOrder
   } from '../../api/evalMG'
   import md5 from 'js-md5'
   import Pagination from '../../components/Pagination'
   import topInfo from '../../components/topInfo'
   import cusNav from '../../components/cusNav'
   import { checkLogin } from '../../utils/util'
   export default {
      data() {
         return {
            loading: false,
            loadInvoiceing: false,
            loadAccounting: false,
            loadPonitsOrdering: false,
            loadPointsLog: false,
            editInvocieVisible: false,
            editPsdVisible: false,
            showApplyTicketVisible: false,
            showRechargeVisible: false,
            showAddCusAdminVisible: false,
            showExportCusAdminVisible: false,
            importCustomerVisible: false,
            orderCodeVisible: false,
            showDistributionVisible: false,
            showPointsLogVisible: false,
            showDistributeVisible: false,
            showUploadVoucherVisible: false,
            billPreviewVisible: false,
            showChooseOrderVisible: false,
            bill_url: '',
            bill_type: '',
            auth: '',
            userInfoForm: [],
            passwordForm: {
               password: '',
               passwords: ''
            },
            multipleSelection: [], //列表勾选框值
            presonDisAble: false,
            applyTicketForm: {
               invoice_id: '',
               total_fee: '',
               order_id: '',
               order_type: ''
            },
            formInlineAccount: {
               page: 1,
               ps: 10,
               search: ''
            },
            importCustomerForm: {
               role_id: '',
               pid: '',
               customerData: []
            },
            orderData: [],
            accountData: [],
            pointsOrderData: [],
            invoiceTitle: '',
            invoiceForm: {
               id: '',
               name: '',
               ein: '',
               invoice_type: '',
               apply_type: '',
               address: '',
               bank: '',
               bank_account: '',
               tel: '',
               email: ''
            },
            customerForm: {
               id: '',
               name: '',
               mobile: '',
               company: '',
               department: '',
               role_id: '',
               email: '',
               pid: ''
            },
            pickerOptions: {
               shortcuts: [{
               text: '最近一周',
               onClick(picker) {
               const end = new Date();
               const start = new Date();
               start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
               picker.$emit('pick', [start, end]);
               }
            }, {
               text: '最近一个月',
               onClick(picker) {
               const end = new Date();
               const start = new Date();
               start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
               picker.$emit('pick', [start, end]);
               }
            }, {
               text: '最近三个月',
               onClick(picker) {
               const end = new Date();
               const start = new Date();
               start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
               picker.$emit('pick', [start, end]);
               }
            }]
            },
            // 对公转账信息
            taxData: [],
            // 用户角色
            roleDataUp: [
               {
                  role_id: 2,
                  role_name: '部门账户'
               },
               {
                  role_id: 3,
                  role_name: '普通账户'
               },
            ],
            roleDataLow: [
               {
                  role_id: 3,
                  role_name: '普通账户'
               }
            ],
            // 上级账户
            pCustomerData: [],
            setHeader:{
               'token': localStorage.getItem('userToken')
            },
            // 用户数据导入地址
            importCustomerAction:webUrl + '/admin/admin/uploadCustomerExcel',

            invoiceData: [],
            chooseInvocieData: [],

            importCusExcelTemp: '',

            // 积分记录数据
            pointsLogData: [],

            voucherData: {
               order_id: ''
            },
            // 用户转账凭证导入
            uploadVoucherAction:webUrl + '/admin/user/uploadTaxVoucher',

            // 订单结果数据
            orderResult: [],
            formInline: {
               page: 1,
               ps: 10,
               search: ''
            },
            distributeForm: {
               points: '',
               disCusId: ''
            },
            applyTicketData: [],
            caseDate: [],
            formInlineOrder: {
               page: 1,
               ps: 10,
               search: '',
               startDate: '',
               endDate: ''
            },
            rechargeDate: [],
            formInlinePointsOrder: {
               page: 1,
               ps: 10,
               search: '',
               startDate: '',
               endDate: ''
            },
            rechargeForm: {
               points: '',
               pay_type: ''
            },
            rechargePlan:[100,300,500,1000,5000],
            // 订单分页参数
            pageparmOrder: {
               currentPage: 1,
               pageSize: 10,
               total: 10
            },
            pageparmAccount: {
               currentPage: 1,
               pageSize: 10,
               total: 10
            },
            // 转账单分页参数
            pageparmPointsOrder: {
               currentPage: 1,
               pageSize: 10,
               total: 10
            },
            // 分页参数
            pageparm: {
               currentPage: 1,
               pageSize: 10,
               total: 10
            }
         }
      },
      // 注册组件
      components: {
         Pagination,
         topInfo,
         cusNav
      },
      created(){
         let auth = localStorage.getItem("sign")
         let user = localStorage.getItem("userData")
         this.userInfoForm = JSON.parse(user)
         this.auth = auth
         this.getCusAdminOrderData()
         this.getInvoiveData()
         this.getCusAdminRechargeOrderData()
         if(this.userInfoForm.role_id != 3){
            this.getCustomerData()
         }
      },
      // 监听
      watch: {
         orderCodeVisible(val){
            if(val){
               console.log(val)
               this.startTimer()
            }
            if(!val){
               console.log(val)
               this.stopTimer()
            }
         }
      },
      methods: {
         checkType(val){
            this.applyForm.type = val
         },
         checkArea(val){
            this.applyForm.area = val
         },
         // 查询发票抬头列表
         getInvoiveData(){
            this.loadInvoiceing = true
            let param = {}
            getUserInvoicePageList(param)
            .then(res=>{
               if(res.code == 200){
                  this.loadInvoiceing = false
                  this.invoiceData = res.data
               }
            })
         },
         // 选中普票
         checkInvoiceOne(){
            this.invoiceForm.invoice_type = 1
         },
         // 选中专票
         checkInvoiceTwo(){
            this.invoiceForm.invoice_type = 2
         },
         // 选中个人
         checkInvoiceThree(){
            this.invoiceForm.apply_type = 2
         },
         // 选中企业
         checkInvoiceFour(){
            this.invoiceForm.apply_type = 1
         },
         // 显示发票抬头编辑弹窗
         showEditInvoice(row){
            if(row){
               this.invoiceForm.id = row.id
               this.invoiceForm.name = row.name
               this.invoiceForm.ein = row.ein
               this.invoiceForm.invoice_type = row.invoice_type
               this.invoiceForm.apply_type = row.apply_type
               this.invoiceForm.address = row.address
               this.invoiceForm.bank = row.bank
               this.invoiceForm.bank_account = row.bank_account
               this.invoiceForm.tel = row.tel
               this.invoiceForm.email = row.email
               this.invoiceTitle = '编辑抬头'
            }else{
               this.invoiceForm.id = ''
               this.invoiceForm.name = ''
               this.invoiceForm.ein = ''
               this.invoiceForm.invoice_type = 1
               this.invoiceForm.apply_type = 1
               this.invoiceForm.address = ''
               this.invoiceForm.bank = ''
               this.invoiceForm.bank_account = ''
               this.invoiceForm.tel = ''
               this.invoiceForm.email = ''
               this.invoiceTitle = '添加抬头'
            }
            this.editInvocieVisible = true
         },
         // 监听数据列表复选框是否选择
         handleSelectionChange(val){
            this.multipleSelection = val;
            let total_fee = 0
            val.forEach((item,index)=>{
               total_fee = Number(total_fee) + Number(item.total_fee)
            })
            this.applyTicketForm.total_fee = total_fee
            console.log(val)
         },
         // 提交发票抬头信息
         commitInvoice(){
            let data = this.invoiceForm
            let param = {}
            // 判断类型
            if(data.invoice_type == 2){
               // 专票
               if(data.name.length<=0 || data.ein.length<=0 || data.address.length<=0 || data.bank.length<=0 || data.bank_account.length<=0 || data.tel.length<=0 || data.email.length<=0){
                  this.$message({
                    type: 'warning',
                    message: '请输入必填项!'
                  }) 
                  return false
               }
               param.name = data.name
               param.ein = data.ein
               param.invoice_type = data.invoice_type
               param.apply_type = 1
               param.address = data.address
               param.bank = data.bank
               param.bank_account = data.bank_account
               param.tel = data.tel
               param.email = data.email
            }
            if(data.invoice_type == 1){
               // 普票
               // 企业
               if(data.apply_type ==1){
                  if(data.name.length<=0 || data.ein.length<=0 || data.email.length <=0){
                     this.$message({
                        type: 'warning',
                        message: '请输入必填项!'
                     }) 
                     return false
                  }
                  param.name = data.name
                  param.ein = data.ein
                  param.invoice_type = data.invoice_type
                  param.apply_type = data.apply_type
                  param.address = ''
                  param.bank = ''
                  param.bank_account = ''
                  param.tel = ''
                  param.email = data.email
               }
               // 个人
               if(data.apply_type ==2){
                  if(data.name.length<=0 || data.email.length <=0){
                     this.$message({
                        type: 'warning',
                        message: '请输入必填项!'
                     }) 
                     return false
                  }
                  param.name = data.name
                  param.ein = ''
                  param.invoice_type = data.invoice_type
                  param.apply_type = data.apply_type
                  param.address = ''
                  param.bank = ''
                  param.bank_account = ''
                  param.tel = ''
                  param.email = data.email
               }
            }
            param.id = data.id
            editInvoice(param)
            .then(res=>{
               if(res.code == 200){
                  this.$message({
                     type: 'success',
                     message: res.msg
                  })
                  this.getInvoiveData()
                  this.editInvocieVisible = false 
               }else{
                  this.$message({
                     type: 'error',
                     message: res.msg
                  }) 
               }
            })
         },
         // 删除发票抬头
         delInvocie(row){
            this.$confirm('确定删除发票抬头?', '提示', {
               confirmButtonText: '确定',
               cancelButtonText: '取消',
               type: 'warning'
            })
            .then(()=>{
                  let id = row.id
                  let param = {
                     id: id
                  }
            delInvoice(param)
               .then(res=>{
                     if(res.code == 200){
                        this.$message({
                           type: 'success',
                           message: res.msg
                        }) 
                        this.getInvoiveData()
                     }else{
                        this.$message({
                           type: 'error',
                           message: res.msg
                        }) 
                     }
                  })
               })
               .catch(() => {
                     this.$message({
                        type: 'info',
                        message: '已取消'
                     })
                  })
         },
         // 显示修改密码弹窗
         showEditPsd(){
            this.editPsdVisible = true
            this.invoiceTitle = '修改密码'
         },
         // 密码修改
         commitPassword(){
            let password = this.passwordForm.password
            let passwords = this.passwordForm.passwords
            if(password.length <= 0 || passwords.length <= 0){
               this.$message({
                  type: 'warning',
                  message: '请填写必填项!'
               }) 
               return false
            }
            if(password != passwords){
               this.$message({
                  type: 'warning',
                  message: '两次输入密码不一致!'
               }) 
               return false
            }
            let param = {
               password: md5(password)
            }
            changeUserPassword(param)
            .then(res=>{
               if(res.code == 200){
                  this.$message({
                     type: 'success',
                     message: res.msg
                  })
                  this.editPsdVisible = false
               }else{
                  this.$message({
                     type: 'error',
                     message: res.msg
                  }) 
                  return false
               }
            })
         },
         // 保存用户信息
         commitUserInfo(){
            // 弹窗提醒
            this.$confirm('确定修改个人信息?', '提示', {
               confirmButtonText: '确定',
               cancelButtonText: '取消',
               type: 'warning'
            })
            .then(()=>{
               let data = this.userInfoForm
               if(data.name.length <= 0){
                  this.$message({
                     type: 'warning',
                     message: '请填写姓名!'
                  }) 
                  return false
               }
               let param = {
                  name: data.name,
                  company: data.company,
                  department: data.department
               }
               editUserInfo(param)
               .then(res=>{
                  if(res.code == 200){
                     this.$message({
                        type: 'success',
                        message: res.msg
                     })
                     this.getUserData()                  
                  }else{
                     this.$message({
                        type: 'error',
                        message: res.msg
                     }) 
                  }
               })
            })
            .catch(() => {
               this.$message({
                  type: 'info',
                  message: '已取消'
               })
            })
            
         },
         // 查询用户订单列表
         getCusAdminOrderData(){
            this.loading = true
            let caseDate = this.caseDate
            if(caseDate&&caseDate.length>0){
               this.formInlineOrder.startDate = caseDate[0]
               this.formInlineOrder.endDate = caseDate[1]
            }else{
               this.formInlineOrder.startDate = ''
               this.formInlineOrder.endDate = ''
            }
            getCusAdminOrderPageList(this.formInlineOrder)
            .then(res=>{
               res = checkLogin(res);
                if(!res){
                 this.$message({
                   type: 'warning',
                   message: '登录已失效,请重新登录!'
                 }) 
                  // 登陆已失效 清除登陆状态
                  setTimeout(() => {
                     window.localStorage.removeItem('userToken');
                     window.localStorage.removeItem('sign');
                     window.localStorage.removeItem('userData');
                     this.$router.push({ path: '/login'});
                     }, 1000)
                }
               if(res.code == 200){
                  this.orderData = res.data.dataList
                  this.pageparmOrder.currentPage = this.formInline.page
                  this.pageparmOrder.pageSize = this.formInline.ps
                  this.pageparmOrder.total = res.data.total
                  this.loading = false
               }else{
                  this.loading = false
               }
            })
         },
         // 查询用户积分充值订单列表
         getCusAdminRechargeOrderData(){
            this.loadPonitsOrdering = true
            let rechargeDate = this.rechargeDate
            if(rechargeDate&&rechargeDate.length>0){
               this.formInlinePointsOrder.startDate = rechargeDate[0]
               this.formInlinePointsOrder.endDate = rechargeDate[1]
            }else{
               this.formInlinePointsOrder.startDate = ''
               this.formInlinePointsOrder.endDate = ''
            }
            getCusAdminRechargeOrderPageList(this.formInlinePointsOrder)
            .then(res=>{
               if(res.code == 200){
                  this.pointsOrderData = res.data.dataList
                  this.pageparmPointsOrder.currentPage = this.formInlinePointsOrder.page
                  this.pageparmPointsOrder.pageSize = this.formInlinePointsOrder.ps
                  this.pageparmPointsOrder.total = res.data.total
                  this.loadPonitsOrdering = false
               }else{
                  this.loadPonitsOrdering = false
               }
            })
         },
         // 显示申请开票弹窗
         showApplyTicket(val,type){
            if(val.total_fee <= 0){
               this.$message({
                  type: 'warning',
                  message: '开票支付金额不能低于0'
               }) 
               return false
            }
            this.applyTicketForm.order_id = val.id
            this.applyTicketForm.total_fee = val.total_fee
            this.applyTicketForm.order_type = type
            this.showApplyTicketVisible = true
         },
         // 抬头发生变化
         changeInvoice(){
            let invocie_id = this.applyTicketForm.invoice_id
            let invoiceData = this.invoiceData
            invoiceData.forEach((o,i)=>{
               if(o.id == invocie_id){
                  this.chooseInvocieData = o
               }
            })
         },
         // 提交发票申请信息
         commitApplyTicket(){
            let data = this.applyTicketForm
            if(data.invoice_id<=0||data.invoice_id.length<=0){
               this.$message({
                  type: 'warning',
                  message: '请选择开票信息'
               }) 
               return false
            }
            let idArr = []
            idArr.push(data.order_id)
            let param = {
               invoice_id: data.invoice_id,
               total_fee: data.total_fee,
               order_id: JSON.stringify(idArr),
               order_type: data.order_type
            }
            addInvoiceApply(param)
            .then(res=>{
               if(res.code == 200){
                  this.$message({
                     type: 'success',
                     message: res.msg
                  })
                  if(param.order_type==1) {
                     this.getCusAdminOrderData()
                  }else{
                     this.getCusAdminRechargeOrderData()
                  }
                  this.showApplyTicketVisible = false
               }else{
                  this.$message({
                     type: 'error',
                     message: res.msg
                  }) 
               }
            })
         },
         // 提交发票申请信息(多订单勾选)
         commitCheckApplyTicket(){
            let data = this.applyTicketForm
            if(data.invoice_id<=0||data.invoice_id.length<=0){
               this.$message({
                  type: 'warning',
                  message: '请选择开票信息'
               }) 
               return false
            }
            let checkIds = this.multipleSelection
            if(checkIds.length <= 0){
               this.$message({
                  type: 'warning',
                  message: '暂无勾选的订单!'
               })
               return false
            }
            let idArr = []
            checkIds.forEach((item,index)=>{
               idArr.push(item.id)
            })
            let ids = JSON.stringify(idArr)
            let param = {
               invoice_id: data.invoice_id,
               total_fee: data.total_fee,
               order_id: ids,
               order_type: data.order_type
            }
            addInvoiceApply(param)
            .then(res=>{
               if(res.code == 200){
                  this.$message({
                     type: 'success',
                     message: res.msg
                  })
                  if(param.order_type==1) {
                     this.getCusAdminOrderData()
                  }else{
                     this.getCusAdminRechargeOrderData()
                  }
                  this.showChooseOrderVisible = false
               }else{
                  this.$message({
                     type: 'error',
                     message: res.msg
                  }) 
               }
            })
         },
         // 用户查看发票
         checkTicket(val){
            let ticket_id = val.ticket_id
            let param = {
               ticket_id: ticket_id
            }
            getCusAdminApplyInvoice(param)
            .then(res=>{
               if(res.code == 200){
                  let url = res.data.bill_url
                  if(url&&url.length > 0){
                     // 查看发票
                     // window.open(url)
                     let type = url.split('.').pop().toLowerCase()
                     this.bill_type = type
                     this.bill_url = url
                     this.billPreviewVisible = true
                  }else{
                     this.$message({
                        type: 'warning',
                        message: '平台管理员开具发票中,请等待'
                     }) 
                  }
               }else{
                  this.$message({
                     type: 'error',
                     message: res.msg
                  }) 
               }
            })
         },
         // 显示积分充值弹窗
         showRecharge(){
            // 查询对公转账信息
            this.getTaxData()
            this.showRechargeVisible = true            
         },
         // 显示可以开发票订单列表,勾选订单申请开票
         showChooseOrder(type){
            // 查询可开发票订单
            let param  = {
               order_type: type
            }
            getCanApplyTicketOrder(param)
            .then(res=>{
               if(res.code == 200){
                  if(res.data.length > 0){
                     this.applyTicketData = res.data
                     this.applyTicketForm.order_type = type
                     this.applyTicketForm.total_fee = 0
                     this.showChooseOrderVisible = true
                  }else{
                     this.$message({
                        type: 'warning',
                        message: '暂无可开发票订单'
                     }) 
                  }
               }else{
                  this.$message({
                     type: 'error',
                     message: res.msg
                  }) 
               }
            })
         },
         // 查询对公转账信息
         getTaxData(){
            let param = {}
            getTransferAccountConfig(param)
            .then(res=>{
               if(res.code == 200){
                  this.taxData = res.data
               }
            })
         },
         // 查询积分记录
         showPointsLog(){
            let param = {}
            this.loadPointsLog = true
            getCusPointsLog(param)
            .then(res=>{
               if(res.code == 200){
                  this.pointsLogData = res.data
                  this.showPointsLogVisible = true
                  this.loadPointsLog = false
               }
            })
         },
         // 显示新增账户弹窗
         showAddCusAdmin(row){
            if(row){
               this.customerForm.id = row.id
               this.customerForm.name = row.name
               this.customerForm.mobile = row.mobile
               this.customerForm.company = row.company
               this.customerForm.department = row.department
               this.customerForm.role_id = role_id
               this.customerForm.email = email
               this.customerForm.pid = pid
            }else{
               this.customerForm.id = ''
               this.customerForm.name = ''
               this.customerForm.mobile = ''
               this.customerForm.company = ''
               this.customerForm.department = ''
               this.customerForm.role_id = ''
               this.customerForm.email = ''
               this.customerForm.pid = ''
            }
            this.showAddCusAdminVisible = true
         },
         // 显示导入账户弹窗
         showExportCusAdmin(){
             // 查询导入文件模板
             getImportCusExcelTemp({})
            .then(res=>{
               if(res.code == 200){
                  this.importCusExcelTemp = res.data.url
                  this.importCustomerForm.pid = ''
                  this.importCustomerForm.role_id = ''
                  this.importCustomerForm.customerData = []
                  this.importCustomerVisible = true
               }
            })


         },
         // 监听角色值发生变化
         listenRole(){
            let role_id = this.customerForm.role_id
            if(role_id&&role_id==3){
               // 一级账户创建三级账户,需要选择账户上级
               this.getSubAccountData()
            }
            console.log(role_id)
         },
         // 监听角色值发生变化(账户导入)
         listenRoleImport() {
            let role_id = this.importCustomerForm.role_id
            if(role_id&&role_id==3){
               // 一级账户创建三级账户,需要选择账户上级
               this.getSubAccountData()
            }
            console.log(role_id)
         },
         // 查询下级账户
         getSubAccountData(){
            let param = {}
            getSubAccount(param)
            .then(res=>{
               if(res.code == 200){
                  this.pCustomerData = res.data
               }
            })
         },
         // 提交新增用户
         commitCustomer(){
            let userData = this.userInfoForm
            let data = this.customerForm
            if(data.name.length <= 0){
               this.$message({
                  type: 'warning',
                  message: '请填写姓名'
               })
               return false
            }
            if(data.mobile.length <= 0){
               this.$message({
                  type: 'warning',
                  message: '请填写手机号'
               })
               return false
            }
            if(data.role_id.length <= 0){
               this.$message({
                  type: 'warning',
                  message: '请选择角色'
               })
               return false
            }
            if(data.role_id == 3&&userData.role_id == 1){
               if(!data.pid || data.pid <= 0 || data.pid.length <= 0){
                  this.$message({
                     type: 'warning',
                     message: '请选择上级账户'
                  })
                  return false
               }
            }
            let param = {
               name: data.name,
               mobile: data.mobile,
               role_id: data.role_id,
               company: data.company,
               department: data.department,
               email: data.email,
               pid: data.pid,
               id: data.id
            }
            editCusAdmin(param)
            .then(res=>{
               if(res.code == 200){
                  this.$message({
                     type: 'success',
                     message: res.msg
                  })
                  this.showAddCusAdminVisible = false
                  this.getCustomerData()
               }else{
                  this.$message({
                     type: 'error',
                     message: res.msg
                  })
               }
            })
         },
         // 查询账户列表
         getCustomerData(){
            this.loadAccounting = true
            getCusAdminPageList(this.formInlineAccount)
            .then(res=>{
               if(res.code == 200){
                  this.accountData = res.data.dataList
                  this.pageparmAccount.currentPage = this.formInlineAccount.page
                  this.pageparmAccount.pageSize = this.formInlineAccount.ps
                  this.pageparmAccount.total = res.data.total
                  this.loadAccounting = false
               }else{
                  this.loadAccounting = false
               }
            })
         },
         // 账户管理搜索
         searchAccount(){
            this.formInlineAccount.page = 1
            this.getCustomerData()
         },
         // 下载账户导入模版
         downloadImportCusTemp(){
            let url = this.importCusExcelTemp
            window.location.href = url
         },
         // 创建积分充值订单
         creRechargeOrder(){
            // 校验积分数量
            let points = this.rechargeForm.points
            if(!points || points.length <= 0){
               this.$message({
                  type: 'warning',
                  message: '请填写充值数量!'
               })
               return false
            }
            if(!/^\d*$/.test(points)){
               this.$message({
                  type: 'warning',
                  message: '请填写正确的充值数量!'
               })
               return false
            }
            createRechargeOrder(this.rechargeForm)
            .then(res=>{
               if(res.code == 200){
                  console.log(res.data)
                  this.orderResult = res.data
                  this.orderCodeVisible = true
               }else{
                  this.$message({
                     type: 'error',
                     message: res.msg
                  })
               }
            })
         },
         // 创建积分充值转账单
         creTaxOrder(){
            let points = this.rechargeForm.points
            if(!points || points.length <= 0){
               this.$message({
                  type: 'warning',
                  message: '请填写充值数量!'
               })
               return false
            }
            if(!/^\d*$/.test(points)){
               this.$message({
                  type: 'warning',
                  message: '请填写正确的充值数量!'
               })
               return false
            }
            createRechargeTaxOrder(this.rechargeForm)
            .then(res=>{
               if(res.code == 200){
                  this.$message({
                     type: 'success',
                     message: res.msg
                  })
                  this.showRechargeVisible = false
               }else{
                  this.$message({
                     type: 'error',
                     message: res.msg
                  })
               }
            })

         },
         // 查询订单详情
         rechargeOrderInfo(){
            let order_sn = this.orderResult.order_sn
            if(order_sn.length <= 0){
               this.$message({
                  type: 'warning',
                  message: '订单号不存在!'
               })
               return false
            }
            let param = { order_sn }
            getRechargeOrderInfo(param)
            .then(res=>{
               if(res.code == 200){
                  if(res.data.status == 2){
                     // 支付成功,跳转评估记录
                     this.$message({
                        type: 'success',
                        message: '支付成功!'
                     })
                     this.orderCodeVisible = false
                     this.showRechargeVisible = false
                     this.stopTimer()
                  }
               }
            })
         },

         // 开始执行定时器
         startTimer(){
            this.intervalId = setInterval(()=>{
               this.rechargeOrderInfo()
            },2000);
         },
         // 结束定时器
         stopTimer(){
            if(this.intervalId){
               clearInterval(this.intervalId);
               this.intervalId = null;
            }
         },
         // 提交账户导入数据
         commitImport(){
            let data = this.importCustomerForm
            let roleId = this.userInfoForm.role_id
            if(data.role_id.length <= 0){
               this.$message({
                  type: 'warning',
                  message: '请选择角色'
               })
               return false
            }
            if(data.role_id == 3 && roleId ==1 && data.pid.length <= 0){
               this.$message({
                  type: 'warning',
                  message: '请选择账户上级'
               })
               return false
            }
            if(data.customerData.length <= 0){
               this.$message({
                  type: 'warning',
                  message: '请上传用户数据表格'
               })
               return false
            }
            let param = {
               pid: data.pid,
               role_id: data.role_id,
               customerData: JSON.stringify(data.customerData)
            }
            importCusAdmin(param)
            .then(res=>{
               if(res.code == 200){
                  this.$message({
                     type: 'success',
                     message: res.msg
                  })
                  this.importCustomerVisible = false
                  this.getCustomerData()
               }else{
                  this.$message({
                     type: 'error',
                     message: res.msg
                  })
               }
            })
         },
         // 显示分配积分弹窗
         showDistribution(val){
            let cus_id = val.id
            this.distributeForm.disCusId = cus_id
            this.showDistributeVisible = true
         },
         // 显示上传凭证弹窗
         showUploadVoucher(val){
            let order_id = val.id
            this.voucherData.order_id = order_id
            this.showUploadVoucherVisible = true
         },
         // 查看转账凭证
         showVoucher(val){
            let url = val.voucher_url
            let type = url.split('.').pop().toLowerCase()
            this.bill_type = type
            this.bill_url = url
            this.billPreviewVisible = true
            // window.open(url)
         }, 
         // 提交积分分配
         commitDistribute(){
            let data = this.distributeForm
            if(!data.points || data.points.length <= 0){
               this.$message({
                  type: 'warning',
                  message: '请填写分配数量!'
               })
               return false
            }
            if(!/^\d*$/.test(data.points)){
               this.$message({
                  type: 'warning',
                  message: '请填写正确的分配数量!'
               })
               return false
            }
            // 确认按钮
            this.$confirm('确定给此账户分配积分?', '提示', {
               confirmButtonText: '确定',
               cancelButtonText: '取消',
               type: 'warning'
            })
            .then(()=>{
               distributionPoints(data)
               .then(res=>{
                  if(res.code == 200){
                     this.$message({
                        type: 'success',
                        message: res.msg
                     })
                     this.getUserData()
                     this.showDistributeVisible = false
                  }else{
                     this.$message({
                        type: 'error',
                        message: res.msg
                     })
                  }
               })
            })
            .catch(() => {
               this.$message({
                  type: 'info',
                  message: '已取消'
               })
            })
         },
         // 删除账户
         delCusAdmin(val){
            let id = val.id
            this.$confirm('确定要删除此账户?', '提示', {
               confirmButtonText: '确定',
               cancelButtonText: '取消',
               type: 'warning'
            })
            .then(()=>{
               let param = {
                  id: id
               }
               delCusAdmin(param)
               .then(res=>{
                  if(res.code == 200){
                     this.$message({
                        type: 'success',
                        message: res.msg
                     })
                     this.getCustomerData()
                  }else{
                     this.$message({
                        type: 'error',
                        message: res.msg
                     })
                  }
               })
            })
            .catch(() => {
               this.$message({
                  type: 'info',
                  message: '已取消'
               })
            })
            console.log(val)
         },
         
         // 查询账户信息
         getUserData(){
            let param  ={}
            getUserInfo(param)
            .then(res=>{
               if(res.code == 200){
                  this.userInfoForm = res.data
               }
            })
         },
         // 监听充值积分数值变化
         listenPoints(){
            let points = this.rechargeForm.points
            if(!/^\d*$/.test(points)){
               this.$message({
                  type: 'warning',
                  message: '请填写正确的分配数量!'
               })
               this.rechargeForm.points = ''
               return false
            }
         },
         // 刷新积分充值订单
         refreshPointsOrderData(){
            this.getCusAdminRechargeOrderData()
         },
         // 清除案件订单日期
         clearDate(){
            this.caseDate = []
         },
         // 清除积分充值订单日期
         clearRechargeDate(){
            this.rechargeDate = []
         },
         // 删除积分充值订单
         delChargeOrder(val){
            let id = val.id
            this.$confirm('确定要删除此订单?', '提示', {
               confirmButtonText: '确定',
               cancelButtonText: '取消',
               type: 'warning'
            })
            .then(()=>{
               let param = {
                  id: id
               }
               cusDelChargeOrder(param)
               .then(res=>{
                  if(res.code == 200){
                     this.$message({
                        type: 'success',
                        message: res.msg
                     })
                     this.getCusAdminRechargeOrderData()
                  }else{
                     this.$message({
                        type: 'error',
                        message: res.msg
                     })
                  }
               })
            })
            .catch(() => {
               this.$message({
                  type: 'info',
                  message: '已取消'
               })
            })
            console.log(val)
         },
         // 分页插件事件
         callFather(parm) {
            this.formInline.page = parm.currentPage
            this.formInline.ps = parm.pageSize
         },
         // 分页插件事件(订单)
         callFatherOrder(parm) {
            this.formInlineOrder.page = parm.currentPage
            this.formInlineOrder.ps = parm.pageSize
            this.getCusAdminOrderData()
         },
         // 分页插件事件(积分充值订单)
         callFatherPointsOrder(parm) {
            this.formInlinePointsOrder.page = parm.currentPage
            this.formInlinePointsOrder.ps = parm.pageSize
            this.getCusAdminRechargeOrderData()
         },
         // 分页插件事件(账户)
         callFatherAccount(parm){
            this.formInlineAccount.page = parm.currentPage
            this.formInlineAccount.ps = parm.pageSize
            this.getCustomerData()
         },


          // 文件上传开始
         // 文件上传成功时的钩子
         handleUploadVoucherSuccess(response, file, fileList) {
            if(response.code == 200){
               this.$message({
                  type: 'success',
                  message: response.msg
               })
               this.getCusAdminRechargeOrderData()
               this.showUploadVoucherVisible = false
            }else{
               this.$message({
                  type: 'error',
                  message: response.msg
               })
            }
         },
         //文件上传前的校验
         beforeUploadVoucher(file) {
            const that = this
            if (!/\.(jpg|png|jpeg|JPG|PNG|pdf)$/.test(file.name)) {
               that.$message({
                  type: 'error',
                  message: '请上传图片或者pdf'
               })
               return false
            }
         }, 

         // 文件上传结束

         // 文件上传开始
         // 删除文件之前的钩子
         beforeImportCusRemove(file, fileList) {
            return this.$confirm(`确定移除 ${file.name}？`);
         },
         // 文件列表移除文件时的钩子
         handleImportCusRemove(file, fileList) {},
         // 文件上传成功时的钩子
         handleImportCusSuccess(response, file, fileList) {
            if(response.code == 200){
               this.$message({
                  type: 'success',
                  message: '导入成功!'
               })
               this.importCustomerForm.customerData = response.data
            }else{
               this.$message({
                  type: 'error',
                  message: response.msg
               })
            }
         },
         //文件上传前的校验
         beforeImportCustomer(file) {
            const that = this
            if (!/\.(xlsx|xls|XLSX|XLS)$/.test(file.name)) {
               that.$message({
                  type: 'error',
                  message: '上传文件只能为excel文件，且为xlsx,xls格式!'
               })
               return false
            }
         }, 

         // 文件上传结束
      }
   }
</script>
<style scoped>
  .login-page {
    text-align: center;
    /* height: 100%; */
  }
  .eval-content {
   width: 1200px;
   /* height: 600px; */
   margin: 0px auto;
   background-color: #fff;
   border-radius: 10px;
  }
  .eval-con-top {
   display: flex;
   margin: 20px 40px;
   padding: 16px 0px;
   border-bottom: 2px solid #eeeeee;
  }
  .eval-con-title {
   color: #2A91DD;
   height: 36px;
   line-height: 36px;
   font-size: 16px;
   font-weight: 700;
  }
  .eval-con-btn {
   width: 120px;
   height: 36px;
   line-height: 36px;
   text-align: center;
   color: #fff;
   background-color: #FF8B36;
   border-radius: 5px;
   margin-left: 20px;
   cursor: pointer;
  }
  .eval-con-search>>>.el-input-group {
   border-radius: 10px !important;
  }
  .eval-con-search>>>.el-input-group__append, .el-input-group__prepend {
   color: #FFFFFF;
   background-color: #2A91DD;
   cursor: pointer;
  }
  .eval-con-search>>>.el-input__inner {
   background-color: #F3F3F3 !important;
   border: none;
  }
  .eval-table {
   width: 1120px;
   margin: 0px auto;
  }
  .eval-table>>> .el-table__header th {
   background-color: #2A91DD !important;
  }
  .eval-table>>> .el-table thead {
   color: #FFFFFF;
  }

  .eval-form {
   width: 1120px;
   margin: 0px auto;
  }
  .eval-form>>>.el-form-item__label {
   text-align: left !important;
   font-weight: 700 !important;
   padding-left: 10px !important;
  }
  .eval-form>>> .el-input__inner {
   background-color: #F3F3F3 !important;
  }
  .eval-form>>> .el-textarea__inner {
   background-color: #F3F3F3 !important;
   min-height: 80px !important;
  }
  .invoice-item {
   display: flex;
   width: 1120px;
   margin: 0px auto;
   margin-bottom: 20px;
  }
  .invoice-type {
   height: 40px;
   line-height: 40px;
   font-weight: 700;
   color: #FFFFFF;
   background-color: #2A91DD;
   border-radius: 4px;
   padding: 0px 10px;
   font-size: 12px;
  }
  .invoice-label {
   margin-left: 40px;
   height: 40px;
   line-height: 40px;
   font-weight: 700;
   font-size: 12px;
  }
  .invoice-text {
   margin-left: 20px;
   text-align: left;
   height: 40px;
   line-height: 40px;
   background-color: #F3F3F3;
   padding-left: 20px;
   color: #666666;
   border-radius: 4px;
   font-size: 12px;
  }
  /* .edit-invoice>>> .el-dialog__header{
   display: none !important;
  }   */

  .invocie-input{
   background-color: #ECEDF4;
   margin-top: 4px;
  }
  .invoice-btn {
   background-color: #ECEDF4;
   padding: 4px 10px;
   border-radius: 50px;
   width: 50%;
   cursor: pointer;
  }
  .invoice-btn-active {
   background-color: #2A91DD;
   color: #FFFFFF;
  }
  .pay_type_item {
   display: flex;
   width: 140px;
   height: 50px;
   border-radius: 10px;
   border: 1px solid #eee;
   margin-right: 10px;
   margin-left: 10px;
 }
 .type_item-right {
   display: flex;
   align-items: center;
   font-size: 14px;
   line-height: 16px;
 }
 .edit-customer>>>.el-input--suffix .el-input__inner {
   height: 32px !important;
 }
 .edit-customer>>>.el-input__icon{
   height: 32px !important;
   line-height: 32px !important;
 }
 .title-flex-end {
   display: flex;
   justify-content: flex-end;
   margin-left: auto;
 }
 .areaPicker {
   margin-top: 2px;
   margin-right: 20px;
 }
 .areaPicker>>>.el-input__inner {
    width: 210px !important;
    height: 40px !important;
    line-height: 40px !important;
    margin-top: -4px !important;
    padding-top: 3px !important;
    padding-bottom: 3px !important;
    padding-left: 20px !important;
    padding-right: 0px !important;
}
.areaPicker>>>i {
    display: none !important;
}
.areaPicker>>>.el-date-editor .el-range-separator {
    line-height: 30px !important;
    color: #999999 !important;
}
.clearBtn {
   padding: 12px 10px;
   border: 1px solid #2A91DD;
   border-radius: 4px;
   color: #ffffff;
   background-color: #2A91DD;
   font-size: 12px;
   cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/views/customer/personCenter.vue